export default {
  engagementCategories: (state) => (categoryType) => {
    return state.engagementCategories[categoryType] || [];
  },
  engagementCategoriesForSelect: (state) => (categoryType) => {
    const categories = state.engagementCategoriesForSelect[categoryType] || [];
    return categories.items.map((category) => ({
      id: category.id,
      text: category.value,
    }));
  },
};
